import { render } from "./CompanyPolicy.vue?vue&type=template&id=59bee500"
import script from "./CompanyPolicy.vue?vue&type=script&lang=ts"
export * from "./CompanyPolicy.vue?vue&type=script&lang=ts"
script.render = render

export default script